import React, { Component } from 'react'
import styled from 'styled-components'
import pattern from '../assets/pattern.png'

const Patterend = styled.div`
    background-repeat: repeat;
    background-image: url(${pattern});
    height: ${props => props.h ? parseFloat(props.h)+'px' : '30px' };
    background-color: #4d4d4d;
    box-shadow: inset 0px 1px 10px 3px rgba(0,0,0,0.65);
`

class Seperator extends Component {
    render() {
        return <Patterend {...this.props} />
    }
}

export default Seperator


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Seperator.jsx